module.exports = __webpack_public_path__ + "static/media/banner2.be6da61c.png";